
<h1 mat-dialog-title translate>Confirm Deletion</h1>
<div mat-dialog-content>
  <p [innerHtml]="data.message | translate"></p>
</div>
<div mat-dialog-actions>
  <button mat-flat-button [mat-dialog-close]="false" translate>Cancel</button>
  <button mat-flat-button color="warn" [mat-dialog-close]="true" translate>Delete</button>
</div>